import { z } from "zod";
import { expirationDateSchema } from "../utils/expiration-date.schema";

export const addPaymentMethodSchema = z.object({
  type: z.enum(["card"]),
  ownerName: z.string().min(1, "Veuillez entrer un nom"),
  cardNumber: z
    .string()
    .min(1, "Veuillez entrer un numéro de carte")
    .refine((value) => {
      const clearedValue = value.replace(/\s/g, "");
      return clearedValue.length === 16;
    }),
  expirationDate: expirationDateSchema,
  cvv: z.string().min(1, "Veuillez entrer un CVV").max(3),
});

export const defaultAddPaymentMethodValues = {
  type: "card" as const,
  ownerName: "",
  cardNumber: "",
  expirationDate: {
    month: undefined,
    year: undefined,
  },
  cvv: "",
};

export type AddPaymentMethodForm = z.infer<typeof addPaymentMethodSchema>;
